const $ = require('jquery');


// ------------------------------------------------------------------------
// Function to modify the Drupal output of the States filter dropdown
// ------------------------------------------------------------------------
function modifyStatesFilter() {

  // Getting setup
  let fauxMenu = '';
  let fauxMenuOptionsOpen = false;

  // Quickly override the text of the 'All' select option that Drupal puts in by defeault
  $('#views-exposed-form-events-page-1 select[name="state"] option[value="All"]').text('All New England Events');
  $('#views-exposed-form-events-page-2 select[name="state"] option[value="All"]').text('All New England Events');
  $('#views-exposed-form-events-block-1 select[name="state"] option[value="All"]').text('All New England Events');
  $('#views-exposed-form-events-block-2 select[name="state"] option[value="All"]').text('All New England Events');
  $('#views-exposed-form-camps-block-1 select[name="state"] option[value="All"]').text('All New England Camps');

  // Loop through each of the Drupal output select element options
  $('select[name="state"] option').each(function(index, element) {
    // Build out the faux jump menu items and add it to the placeholder element
    fauxMenu = '<div class="jumpmenuitem jumpmenuitem-' + element.value.toLowerCase() + '" data-value="' + element.value + '" ><span class="icon-state-' + element.value.toLowerCase() + '"></span> ' + element.text + '</div>';
    $('#fauxjumpmenu-options').append(fauxMenu);
  });

  // Handle the opening of the faux jump menu options
  $('#fauxjumpmenu-select').on('click', function(e) {
    e.preventDefault();
    if (!fauxMenuOptionsOpen) {
      $('#fauxjumpmenu-options').slideDown(500);
      $('#fauxjumpmenu-select').addClass('open');
      fauxMenuOptionsOpen = true;
    } else {
      $('#fauxjumpmenu-options').slideUp(500);
      setTimeout(function() {
        $('#fauxjumpmenu-select').removeClass("open");
      }, 500);
      fauxMenuOptionsOpen = false;
    }
  });

  // Get the selected value for use later
  // First set the generic value
  let selectedValue = 'All';

  // Now test for a selected value from either of the dropdowns
  if ($('select[name="state"]').length) {
    selectedValue = $('select[name="state"]').children(":selected").val();
  }

  // Update the text of the h3 element to match the appropiate state selected
  // and update the faux select element's html as well
  switch (selectedValue) {
    case 'All':
      $('#state-walks-races-heading').text($('#state-walks-races-heading').text().replace('switch', 'All'));
      $('#state-camps-heading').text($('#state-camps-heading').text().replace('switch', 'New England'));
      $('#fauxjumpmenu-select').html('<span class="icon-state-all"></span> All in New England');
      break;

    case 'me':
      $('#state-walks-races-heading').text($('#state-walks-races-heading').text().replace('switch', 'Maine'));
      $('#state-camps-heading').text($('#state-camps-heading').text().replace('switch', 'Maine'));
      $('#fauxjumpmenu-select').html('<span class="icon-state-' + selectedValue.toLowerCase() + '"></span> Maine');
      break;

    case 'ma':
      $('#state-walks-races-heading').text($('#state-walks-races-heading').text().replace('switch', 'Massachusetts'));
      $('#state-camps-heading').text($('#state-camps-heading').text().replace('switch', 'Massachusetts'));
      $('#fauxjumpmenu-select').html('<span class="icon-state-' + selectedValue.toLowerCase() + '"></span> Massachusetts');
      break;

    case 'nh':
      $('#state-walks-races-heading').text($('#state-walks-races-heading').text().replace('switch', 'New Hampshire'));
      $('#state-camps-heading').text($('#state-camps-heading').text().replace('switch', 'New Hampshire'));
      $('#fauxjumpmenu-select').html('<span class="icon-state-' + selectedValue.toLowerCase() + '"></span> New Hampshire');
      break;

    case 'ri':
      $('#state-walks-races-heading').text($('#state-walks-races-heading').text().replace('switch', 'Rhode Island'));
      $('#state-camps-heading').text($('#state-camps-heading').text().replace('switch', 'Rhode Island'));
      $('#fauxjumpmenu-select').html('<span class="icon-state-' + selectedValue.toLowerCase() + '"></span> Rhode Island');
      break;

    default:
      $('#state-walks-races-heading').text($('#state-walks-races-heading').text().replace('switch', 'All'));
      $('#state-camps-heading').text($('#state-camps-heading').text().replace('switch', 'All'));
      $('#fauxjumpmenu-select').html('<span class="icon-state-all"></span> All in New England');
  }

  // Handle the clicking of each of the faux jump menu items
  $('.jumpmenuitem').click(function() {

    // Match up the clicked on faux menu item to the form's actual select element
    $('#views-exposed-form-events-page-1 select[name="state"]').val($(this).data('value'));
    $('#views-exposed-form-events-page-2 select[name="state"]').val($(this).data('value'));
    $('#views-exposed-form-events-block-1 select[name="state"]').val($(this).data('value'));
    $('#views-exposed-form-events-block-2 select[name="state"]').val($(this).data('value'));
    $('#views-exposed-form-camps-block-1 select[name="state"]').val($(this).data('value'));

    // Trigger the actual form to submit by mimicing a click on the form's submit button
    $('#views-exposed-form-events-page-1 .form-submit').trigger('click');
    $('#views-exposed-form-events-page-2 .form-submit').trigger('click');
    $('#views-exposed-form-events-block-1 .form-submit').trigger('click');
    $('#views-exposed-form-events-block-2 .form-submit').trigger('click');
    $('#views-exposed-form-camps-block-1 .form-submit').trigger('click');

  });

}

// Run the function immediately AND after each Ajax call completes
modifyStatesFilter();
$(document).ajaxComplete(function() {
  modifyStatesFilter();
});





// ------------------------------------------------------------------------
// Function to modify the Drupal output of the Categories filter dropdown
// ------------------------------------------------------------------------
function modifyCategoriesFilter() {

  // Getting setup
  let fauxCatMenu = '';
  let fauxCatMenuOptionsOpen = false;

  // Quickly override the text of the 'All' select option that Drupal puts in by defeault
  $('.views-exposed-form select[name="category"] option[value="All"]').text('All Event Categories');

  // Loop through each of the Drupal output select element options
  $('.views-exposed-form select[name="category"] option').each(function(index, element) {
    // Build out the faux categories jump menu items and add it to the placeholder element
    fauxCatMenu = '<div class="catjumpmenuitem catjumpmenuitem-' + element.value.toLowerCase() + '" data-value="' + element.value + '">' + element.text + '</div>';
    $('#fauxcatjumpmenu-options').append(fauxCatMenu);
  });

  // Handle the opening of the faux categories jump menu options
  $('#fauxcatjumpmenu-select').on('click', function(e) {
    e.preventDefault();
    if (!fauxCatMenuOptionsOpen) {
      $('#fauxcatjumpmenu-options').slideDown(500);
      $('#fauxcatjumpmenu-select').addClass('open');
      fauxCatMenuOptionsOpen = true;
    } else {
      $('#fauxcatjumpmenu-options').slideUp(500);
      setTimeout(function() {
        $('#fauxcatjumpmenu-select').removeClass("open");
      }, 500);
      fauxCatMenuOptionsOpen = false;
    }
  });

  // Get the selected value for use later
  // First set the generic value
  let selectedCatValue = 'All';

  // Now test for a selected value from either of the dropdowns
  if ($('.views-exposed-form select[name="category"]').length) {
    selectedCatValue = $('.views-exposed-form select[name="category"]').children(":selected").val();
  }

  // Update the text of the h3 element to match the appropiate state selected
  // and update the faux select element's html as well
  switch (selectedCatValue) {
    case 'All':
      $('#fauxcatjumpmenu-select').html('All Event Categories');
      break;

    case '1': // Walks and Races
      $('#fauxcatjumpmenu-select').html('Walks and Races');
      break;

    case '2': // General
      $('#fauxcatjumpmenu-select').html('General Events');
      break;

    case '3': // Career Navigator
      $('#fauxcatjumpmenu-select').html('Career Navigator Events');
      break;

    case '4': // SHARE Groups
      $('#fauxcatjumpmenu-select').html('SHARE Group Events');
      break;

    case '5': // Young Leaders
      $('#fauxcatjumpmenu-select').html('Young Leaders Network Events');
      break;

    default:
      $('#fauxcatjumpmenu-select').html('All Event Categories');
  }

  // Handle the clicking of each of the faux jump menu items
  $('.catjumpmenuitem').click(function() {

    // Match up the clicked on faux menu item to the form's actual select element
    $('#views-exposed-form-events-page-1 select[name="category"]').val($(this).data('value'));
    $('#views-exposed-form-events-page-2 select[name="category"]').val($(this).data('value'));
    $('#views-exposed-form-events-block-1 select[name="category"]').val($(this).data('value'));

    // Trigger the actual form to submit by mimicing a click on the form's submit button
    $('#views-exposed-form-events-page-1 .form-submit').trigger('click');
    $('#views-exposed-form-events-page-2 .form-submit').trigger('click');
    $('#views-exposed-form-events-block-1 .form-submit').trigger('click');

  });

}

// Run the function immediately AND after each Ajax call completes
modifyCategoriesFilter();
$(document).ajaxComplete(function() {
  modifyCategoriesFilter();
});
